module.exports = __webpack_public_path__ + "img/status-1.2a017e04.png";